import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import dateformat from 'dateformat'
import API from '../../api'
import Loader from '../common/Loader'

class EventPage extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: true
    }
    API.fetchEvent(props.match.params.event)
      .then(res => {
        let data = res.data
        this.setState({
          event: data,
          loading: false
        })
      })
  }

  render () {
    return (
      <div className='container'>
        <Loader loading={this.state.loading} />
        {!this.state.loading &&
          <h1>{this.state.event.name}</h1>
        }
        {!this.state.loading &&
          <div className='table-responsive-lg'>
            <table className='table table-hover'>
              <thead>
                <tr>
                  <th style={{width: '40%'}}>Race</th>
                  <th style={{width: '30%'}}>Distance</th>
                  <th style={{width: '30%'}}>Start</th>
                </tr>
              </thead>
              <tbody>
                {this.state.event.races.map((r, index) =>
                  <tr key={index}>
                    <td><Link to={`/${this.state.event.slug}/${r.id}`} >{r.name}</Link></td>
                    <td>{r.distance} km</td>
                    <td>{dateformat(r.start, 'yyyy-mm-dd HH:MM')}</td>
                    <td />
                  </tr>)
                }
              </tbody>
            </table>
          </div>
        }
      </div>
    )
  }
}

export default EventPage
